import axios from 'axios';
import BaseApi from './base-api';
import numeral from 'numeral';

class ChatsApi extends BaseApi {
  getChatActivity(filters) {
    let query = '';
    Object.keys(filters).forEach((filter, index) => {
      if (index > 0) {
        query += '&';
      }
      query += `${filter}=${filters[filter]}`;
    });

    return axios
      .get(`${this.baseUrl}/notes/activity?${query}`)
      .then((response) => {
        return {
          ok: true,
          activity: response.data,
          total: numeral(response.headers['total']).value(),
          pageSize: numeral(response.headers['per-page']).value(),
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }
}

export const chatsApi = new ChatsApi();



// WEBPACK FOOTER //
// ./src/services/api/chats-api.js